import React from 'react';
import { Table } from 'complexComponents';
import { externalPaymentsClickContext } from './context';
import {} from './ExternalPaymentsListTable.types';
import { columns } from './paymentColumns';
export const ExternalPaymentsListTable = ({ onClick, data }) => (React.createElement(externalPaymentsClickContext.Provider, { value: onClick },
    React.createElement(Table, { columns: columns, data: data })));
